import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import getHumanMetaData from './getHumanMetaData';
import getHorseMetaData from './getHorseMetaData';
import getCourseMetaData from './getCourseMetaData';

const getMetaData = (type, page, name, profile) => {
    switch (type) {
        case 'course': return getCourseMetaData(page, name);
        case 'horse': return getHorseMetaData(page, profile);
        default: return getHumanMetaData(type, page, name);
    }
};

const MetaData = ({ type, page, name, profile }) => {
    const { title, description } = getMetaData(type, page, name, profile);

    return (
        <Helmet
            title={title}
            meta={[{
                name: 'description',
                content: description.replace(/\s\s+/g, ' '),
            }]}
        />
    );
};

MetaData.propTypes = {
    type: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    name: PropTypes.string,
    profile: PropTypes.shape({}),
};

export default MetaData;



// WEBPACK FOOTER //
// ./src/js/shared/metaData/MetaData.jsx